<div class="modal-header">
    <h4 class="modal-title">Journal Entry</h4>
</div>
<div class="modal-body">
    @if (journalEntry) {
    <dx-form [formData]="journalEntry" validationGroup="journalEntryValidationGroup" [readOnly]="readOnly">
        <dxi-item dataField="id" [editorOptions]="{ disabled: true }"></dxi-item>
        <dxi-item dataField="docNumber"></dxi-item>
        <dxi-item dataField="journalEntryDate" [label]="{ text: 'Date' }" editorType="dxDateBox" [isRequired]="true"></dxi-item>
        <dxi-item dataField="amount" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 } }" [isRequired]="true"></dxi-item>
        <dxi-item
            dataField="debitAccountId"
            [label]="{ text: 'Debit Account' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: quickBooksAccounts, displayExpr: 'displayName', valueExpr: 'id' }"
            [isRequired]="true"
        ></dxi-item>
        <dxi-item
            dataField="creditAccountId"
            [label]="{ text: 'Credit Account' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: quickBooksAccounts, displayExpr: 'displayName', valueExpr: 'id' }"
            [isRequired]="true"
        ></dxi-item>
        <dxi-item dataField="description"></dxi-item>
        <dxi-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"></dxi-item>
    </dx-form>
    }
</div>
<div class="modal-footer">
    @if (!readOnly) {
    <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    }
    <button type="button" class="btn btn-light" (click)="cancel()">{{ readOnly ? "Close" : "Cancel" }}</button>
</div>
